<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('menu.protocol')" 
        target="/Main" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconEventList             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('menu.protocolfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>
        <table class="table-auto w-full p-8">
          <tbody>
            <!-- <template v-for="log in this.eventLogs" :key="log.id"> -->
            <template v-for="(log, index) in eventLogs" :key="log.id">

            <tr>
              <td v-if="this.isNewDate(log,index)" colspan="2" class="px-4 py-1 text-center">
                <div class="relative flex items-center">
                  <div class="flex-grow border-t border-gray-400"></div>
                  <span class="mx-4 text-gray-600 text-sm font-medium">
                    {{ this.$dayjs.utc(log.time)?.local().format('DD.MM.YYYY')  }}
                  </span>
                  <div class="flex-grow border-t border-gray-400"></div>
                </div>
              </td>
            </tr>
              <tr>
                <td class="px-4 whitespace-nowrap">{{ this.$dayjs.utc(log.time)?.local().format('HH:mm:ss')  }}</td>

                <!-- <td>{{this.decodeHtml(log.module)}}</td>  -->
                <td :class="{'px-2 sm:px-4 whitespace-normal break-words': true}">
                  <strong class="inline-flex items-center gap-1">
                    <IconError v-if="log.level === 'ERROR'" class="w-4 h-4 text-red-500 shrink-0"/>
                    <IconWarn v-else-if="log.level === 'WARN'" class="w-4 h-4 text-yellow-500 shrink-0"/>
                    {{ isGerman ? this.decodeHtml(log.messageDE) : this.decodeHtml(log.message) }}
                  </strong>
                </td>
              </tr>
              </template>
          </tbody>

        </table>
      </template>
    </SettingsBody>

    <div v-if="!isLoading" class="flex flex-col items-start space-y-2">
      
      <button :disabled="this.$store.state.WbId != this.$store.state.WbLogId" @click="generateZipAndDownload" class="
        inline-flex items-center cursor-pointer px-4
        py-2 h-12
        rounded-lg border-2 border-transparent
        font-semibold text-lg text-skin-b-invt 
        bg-skin-active128 text-skin-inverted
        disabled:opacity-50 disabled:hover:bg-skin-active128
        disabled:cursor-not-allowed 
        hover:bg-skin-active96
        focus:bg-skin-active128 focus:outline-none focus:ring-0 
        active:bg-skin-active128 
        transition duration-300 ease-in-out">
        
        <svg class="mr-2 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          <path d="M5.5 16q-.625 0-1.062-.438Q4 15.125 4 14.5V13h1.5v1.5h9V13H16v1.5q0 .625-.438 1.062Q15.125 16 14.5 16Zm3.75-3V5.875L7.062 8.062 6 7l4-4 4 4-1.062 1.062-2.188-2.187V13Z"/>
        </svg>

        {{ $t('eventLog.downloadLog')}}
      </button>
      <span class="mt-1 text-sm text-gray-500">
        {{ this.$store.state.WbId == this.$store.state.WbLogId 
          ? $t('eventLog.supportOnly') 
          : $t('eventLog.warningOnlyLoginWb',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
        
      </span>
      <div class="h-4"></div>
      <div class="h-4"></div>
    </div>

  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconEventList from './icons/IconEventList.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import IconWarn from './icons/IconWarn.vue'
import IconError from './icons/IconError.vue'
//import IconDownload from './icons/IconDownload.vue'

import { useI18n } from 'vue-i18n'


function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },  
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconEventList,
      SettingsHeader, SettingsBody, IconWarn, IconError
    }, 
  data() {
    return {
          eventLogs: {},
          isShrunk: false,
          isLoading: false
    }
  },
  computed: {
    isGerman() {
         return (navigator?.language || '').startsWith('de');
    }  
  },
  methods: {
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    loadLogFile() {
      console.log(this.$store.state);
      this.isLoading = true;

        let eventLogUrl = 'wallbox/info.php?action=get_event_log&user='+this.$store.state.token+'&client='+this.$store.state.WbId;

        const eventLogsRequest = this.axios.get(eventLogUrl);

      this.axios
        .all([eventLogsRequest])
        .then(
            this.axios.spread((...responses) => {
                const responseclient_Log = responses[0];

                if(responseclient_Log.data.status=='token'){
                      this.$router.push({path: '/'});             
                  }else if(responseclient_Log.data.status=='ok'){

                    this.eventLogs = responseclient_Log?.data?.tbl_eventlog;    

                    console.log(this.eventLogs);

                }else{
                  console.log('Error get Settings Table');
                }

            this.isLoading = false;
            })
        )
        .catch((errors) => {
            this.isLoading = false;
            console.error(errors);
        });


    },

    downloadLog(){
      this.isLoading = true;
      setTimeout(() => {
        console.log("5 Sekunden sind vorbei");
      this.isLoading = false;
      }, 5000);

    },
    async generateZipAndDownload() {
      try {
        this.isLoading = true;
        // 1. Evereset should zip all logs! 
        const response = await this.axios.get(
          'wallbox/info.php?action=zip_everest_logs&user=' + this.$store.state.token + '&client=-1'
        );

        if (response.data.status !== 'ok') {
          console.log('Error send zip_everest_logs command');
          this.isLoading = false;
          return;
        }

        //Wait 3 Seconds
        await wait(3000);

        // 2. Polling (check every second if log file is ready)
        const url = 'wallbox/download/mainLog.zip';

        let exists = false;
        let attempts = 0;
        const maxAttempts = 10; 

        while (!exists && attempts < maxAttempts) {
          await wait(1000);
          attempts++;

        try {
          const res = await this.axios.get(url, {
            responseType: 'blob'
          });

          // Wenn wir hier sind → Datei existiert
          if (res.status === 200 && res.data.size > 0) {
            exists = true;
          }

        } catch (err) {
          // Datei noch nicht da (z.B. 404)
        }
       }

        if (!exists) {
          console.log('Datei nicht gefunden / Timeout');
          this.isLoading=false;
          return;
        }

        console.log('mainLog.zip exists');

        //mainLog.zip exists
        
        //create Filename
        const d = new Date();
        const pad = n => n.toString().padStart(2, '0');

        const date =
          `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}_` +
          `${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;

        const filename = `Log_${this.$store.state.WbLogSerial}_${date}.zip`;        

        console.log(filename);

        // Download file
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();

      } catch (error) {
        console.log(error);
      }

      //delete current log file from download folder  
      await this.axios.get(
        'wallbox/info.php?action=delete_everest_logs&user=' + this.$store.state.token + '&client=-1'
      );
      
      this.isLoading=false;
      return;

    },
  

    isNewDate(log, index) {

      // Erste Zeile immer Datum zeigen
        if (index === 0) return true;

        const currentDate = this.$dayjs.utc(log.time).local().format('DD.MM.YYYY');
        const prevDate = this.$dayjs.utc(this.eventLogs[index - 1].time).local().format('DD.MM.YYYY');

        return currentDate !== prevDate;    
      }    

  },
  created() {  
    this.loadLogFile();
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
